module.exports = __webpack_public_path__ + "static/media/disenio.6046c05b.png";